import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { AppBar, Toolbar, Typography } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import IconButton from '@material-ui/core/IconButton';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Status } from '../../context/RestAPI';
import AccordionList from '../AccordionList';
import styles from './styles';
import Actions, { ActionType } from '../Actions';


function DetailsOverview({ classes, applicationObjects, applicationObject, actions, onCloseDetails }) {
    return (
        <>
        <AppBar className={classes.paperHeader} position="static" color="default" elevation={0}>
            <Toolbar>
                <Grid container spacing={0} alignItems="center">
                    <Grid item>
                        <IconButton color="inherit" onClick={onCloseDetails} >
                            <ArrowBackIcon />
                        </IconButton>
                    </Grid>
                    <Grid item xs>
                        <Typography className={classes.detailsTitle}>
                            {applicationObject.getTitle()}
                        </Typography>
                    </Grid>
                    <Grid item>
                        <Actions actions={actions} item={applicationObject} type={ActionType.Text} />
                    </Grid>
                </Grid>
            </Toolbar>
        </AppBar>

        {((applicationObjects.status == Status.Success) && applicationObject) ? (
			<AccordionList applicationObjects={applicationObjects} applicationObject={applicationObject} />
		) : null }
		{(applicationObjects.status == Status.Loading) ? (
			<div className={classes.contentWrapper}>
				<div className={classes.progressbar}>
					<CircularProgress />
				</div>
			</div>
		) : null }
		{(applicationObjects.status == Status.Init) ? (
			<Typography className={classes.contentWrapper} color="textSecondary" align="center">
				Authentication, please wait ...
			</Typography>
		) : null }
		{(applicationObjects.status == Status.Unauthorized) ? (
			<Typography className={classes.contentWrapper} color="textSecondary" align="center">
				Authentication failed! Please refresh your session.
			</Typography>
		) : null }
		{(applicationObjects.status == Status.Empty) ? (
			<Typography className={classes.contentWrapper} color="textSecondary" align="center">
				No data found.
			</Typography>
		) : null }
		{(applicationObjects.status == Status.Error) ? (
			<Typography className={classes.contentWrapper} color="textSecondary" align="center">
				Wupps, an error occured! Please try again later.
			</Typography>
		) : null }
        </>
    );
}

DetailsOverview.propTypes = {
	classes: PropTypes.object.isRequired,
	applicationObjects: PropTypes.object.isRequired,
	applicationObject: PropTypes.object.isRequired,
	actions: PropTypes.array.isRequired,
	onCloseDetails: PropTypes.func.isRequired
}

export default withStyles(styles)(DetailsOverview);
